
(function () {
  function enableVideoControls(scope) {
    (scope || document).querySelectorAll('media-gallery video').forEach(function (video) {
      video.controls = true;
      video.setAttribute('controls', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'metadata';

      // On garde la vidéo muette au départ pour respecter Safari/Chrome,
      // mais le client peut activer le son avec les contrôles.
      if (!video.hasAttribute('data-maternitys-user-unmuted')) {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
      }

      video.addEventListener('volumechange', function () {
        if (!video.muted && video.volume > 0) {
          video.setAttribute('data-maternitys-user-unmuted', 'true');
          video.removeAttribute('muted');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enableVideoControls(document); });
  } else {
    enableVideoControls(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    enableVideoControls(event.target);
  });

  document.addEventListener('click', function () {
    setTimeout(function () { enableVideoControls(document); }, 100);
  }, true);
})();
